import { ChipContainer } from './Chip.styles';
import { Box, Button, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { ChipComponent } from './Chip.types';
import { AccessControl } from '../AccessControl/AccessControl';

export const Chip: ChipComponent = ({
  text,
  onDelete,
  isDeleting,
  backgroundColor,
  permission,
}) => (
  <ChipContainer container item data-testid={`chip-${text}`} backgroundColor={backgroundColor}>
    <Box mr={1}>
      <Typography variant="body2">{text}</Typography>
    </Box>
    <AccessControl
      permission={permission}
      renderIfNoAccess={
        <Tooltip
          title={
            <Typography variant="caption" color={() => 'white'}>
              You do not have permissions to perform this action.
              <br />
              Required permissions: {/*@ts-ignore*/}
              <Typography variant="caption" weight="bold">
                {permission}
              </Typography>
            </Typography>
          }
        >
          <Button type="button" disabled data-testid="disabled-delete-chip">
            <Icon.Cancel size="sm" />
          </Button>
        </Tooltip>
      }
    >
      <Button type="button" onClick={onDelete} disabled={isDeleting} data-testid="delete-chip">
        <Icon.Cancel size="sm" />
      </Button>
    </AccessControl>
  </ChipContainer>
);
